import { z } from 'my-zod'

export const shortIdPrefixOptions = [
  'AC',
  'AO',
  'AOP',
  'ANM',
  'AP',
  'APT',
  'BC',
  'C',
  'CO',
  'D',
  'DP',
  'DWC',
  'EC',
  'MFP',
  'O',
  'OC',
  'OCL',
  'OO',
  'P',
  'PT',
  'Q',
  'R',
  'RDR',
  'SB',
  'WO',
  'DIS',
  'GRP',
  'V',
  'DSP',
  'PROM'
] as const
export const shortIdPrefixEnum = z.enum(shortIdPrefixOptions)

export type shortIdPrefix = (typeof shortIdPrefixOptions)[number]
